module.exports = __webpack_public_path__ + "img/back_img.997f2c5c.png";